export default __webpack_public_path__ + "static/media/daniela_l.790ae388.jpg";